module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticStyle: {
      "text-align": "center"
    },
    attrs: {
      "id": "main"
    }
  }, [_c('h1', [_vm._v(_vm._s(_vm.$t("404.title")))]), _vm._v(" "), _c('h2', [_vm._v("404")]), _vm._v(" "), _c('img', {
    attrs: {
      "src": "https://http.cat/404.jpg",
      "width": "300"
    }
  })])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-421b1dcc","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/404.vue
// module id = 563
// module chunks = 21